<template>
  <v-container class="iframe-body modal_content" text-center>
    <div class="Step-3">{{ $t('verify.title') }}</div>
    <alert id="alert" v-if="snackbar" :errorMsg="errorMsg" />
    <v-flex>
      <p class="select">{{ $t('verify.data') }} {{ idt.text }}</p>
      <FlipCard class="id-card" :hasBack="card.back" v-if="card.front">
        <template slot="front">
          <v-container>
            <v-layout row justify-space-between wrap>
              <v-col
                :style="idCardStyle()"
                cols="12"
                class="field idt-name"
                md12
              >
                <label>{{ card.idtName.label[$i18n.locale] }}</label>
                <p>{{ card.idtName.value }}</p>
              </v-col>

              <v-col
                v-for="(field, name, index) in card.front"
                v-bind:key="index"
                class="field"
                :cols="calcCols(name)"
                :sm="calcCols(name)"
              >
                <div :style="idCardStyle()">
                  <label>{{ field.label[$i18n.locale] }}</label>
                  <p>{{ field.value }}</p>
                </div>
              </v-col>
            </v-layout>
          </v-container>
        </template>
        <template slot="back">
          <v-container>
            <v-layout row justify-space-between wrap>
              <v-col
                v-for="(field, name, index) in card.back"
                v-bind:key="index"
                class="field"
                :cols="calcCols(name)"
                :sm="calcCols(name)"
              >
                <div :style="idCardStyle()">
                  <label>{{ field.label[$i18n.locale] }}</label>
                  <p>{{ field.value }}</p>
                </div>
              </v-col>
            </v-layout>
          </v-container>
        </template>
      </FlipCard>
    </v-flex>
  </v-container>
</template>

<script>
import * as WallidConst from '@/wallid/const.js';
import FlipCard from '@/components/FlipCard';
import { mapGetters } from 'vuex';
import { VERIFY_DATA_ID } from '@/stores/consts';

export default {
  name: 'Verify',
  components: {
    FlipCard,
  },
  computed: {
    ...mapGetters(['data', 'authToken', 'dropdown_identity', 'idt']),
    snackbar: {
      get() {
        return this.$store.state.snackbar;
      },
      set(newValue) {
        return this.$store.commit('snackbar', newValue);
      },
    },
    errorMsg: {
      get() {
        return this.$store.state.errorMsg;
      },
      set(newValue) {
        return this.$store.commit('errorMsg', newValue);
      },
    },
  },
  created() {
    this.session_id_tsp = window.session_id_tsp;
  },
  watch: {
    data(value) {
      if (value) {
        this.getCCValues({ idt: this.idt, obj: this.data });
      }
    },
  },
  methods: {
    getCCValues: function({ idt, obj }) {
      let fields = {};
      let side = 'front';
      fields[side] = {};

      fields.idtName = {
        label: { pt: 'Nome tipo de ID', en: 'ID Type Name' },
        value: idt.text,
      };

      fields.idtName.value = fields.idtName.value.replace('ShuftiPro', '');
      let idtPrefix = idt.value.substring(0, 9);
      switch (idtPrefix) {
        case WallidConst.CC_PT:
          Object.keys(WallidConst.CC_PT_LABELS).forEach((label) => {
            if (label == 'PARENTS') {
              side = 'back';
              fields[side] = {};
              fields[side][label] = {
                label: WallidConst.CC_PT_LABELS[label],
                value:
                  obj.find((e) => e.item == 'GivenNameFather').value +
                  ' ' +
                  obj.find((e) => e.item == 'SurnameFather').value +
                  ' * ' +
                  obj.find((e) => e.item == 'GivenNameMother').value +
                  ' ' +
                  obj.find((e) => e.item == 'SurnameMother').value,
              };
            } else {
              fields[side][label] = {
                label: WallidConst.CC_PT_LABELS[label],
                value: obj.find((e) => e.item == label).value,
              };
            }
          });
          break;

        case WallidConst.SHUFTI_INT:
          Object.keys(WallidConst.SHUFTI_PT_LABELS).forEach((label) => {
            if (label == 'parents_name') {
              side = 'back';
              fields[side] = {};
            }
            let value = obj.find((e) => e.item == label);
            if (value) {
              fields[side][label] = {
                label: WallidConst.SHUFTI_PT_LABELS[label],
                value: value.value,
              };
            } else {
              return;
            }
          });

          break;

        case WallidConst.CMD_PT:
          Object.keys(WallidConst.CMD_PT_LABELS).forEach((label) => {
            fields[side][label] = {
              label: WallidConst.CMD_PT_LABELS[label],
              value: obj.find((e) => e.item == label).value,
            };
          });
          break;

        default:
          break;
      }

      // fields.idt = { label: "ID Type", value: obj.dataID.data.idt };
      if (
        typeof fields.back == 'object' &&
        Object.keys(fields.back).length === 0 &&
        fields.back.constructor === Object
      ) {
        delete fields.back;
      }
      this.card = fields;
    },
    calcCols(name) {
      let _idt = this.idt.value.substring(0, 10);
      switch (_idt) {
        case 'CMD_PT':
          return name == 'Name' ? 12 : 6;
        case 'CC_PT':
          return name == 'Surname'
            ? 9
            : name == 'PARENTS'
            ? 12
            : name == 'Sex' ||
              name == 'Height' ||
              name == 'Country' ||
              name == 'Birthdate' ||
              name == 'Givenname'
            ? 3
            : name == 'CivilianIdNumber' || name == 'Validityenddate'
            ? 6
            : 4;

        case 'SHUFTI_CC_':
          return name == 'last_name'
            ? 7
            : name == 'parents_name'
            ? 12
            : name == 'expiry_date'
            ? 4
            : 4;
      }
    },
    idCardStyle() {
      switch (this.idt.value) {
        case 'CMD_PT':
          return 'padding: 12px';
        default:
          return 'padding: 2px';
      }
    },
    verify: function() {
      console.log('*************** verifyDataID ***************************');

      this.$store
        .dispatch(VERIFY_DATA_ID)
        .then(this.handleSucess)
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 401) {
              this.$store.commit('verify', false);
              this.errorMsg = 'expired';
              // this.$eventHub.$emit('eventUpdate', {
              //   time: 1,
              //   params: {
              //     user_id: window.Intercom('getVisitorId'),
              //     msg: this.$i18n.t('intercom.invalid'),
              //   },
              // });
            } else {
              console.log('response = ', error.response);
              console.log('response.status = ', error.response.status);
              this.errorMsg = 'revoked';
            }
          }
          this.snackbar = true;
          this.$store.commit('verify', false);
          this.$store.commit('loading', false);
          this.errorMsg = 'expired';
          this.$nextTick(() => {
            document.getElementById('step-top').scrollIntoView(true);
          });
        });
    },
    handleSucess(verifyIDToken) {
      if (!verifyIDToken) {
        this.errorMsg = 'invalid';
        this.snackbar = true;
        this.$store.commit('verify', false);

        this.$eventHub.$emit('eventUpdate', {
          time: 1,
          params: {
            msg: this.$i18n.t('intercom.invalid'),
          },
        });
      } else {
        this.$store.commit('verifyIDToken', verifyIDToken);
        this.$store.commit('verify', false);

        console.log('-- CALL SIGN --');
        this.$eventHub.$emit('sign-event');
        this.$store.commit('signing', true);
      }

      return;
    },
  },
  data() {
    return {
      striped: false,
      card: {},
      session_id_tsp: '',
    };
  },
};
</script>
<style lang="scss">
@media screen and (max-width: 720px) {
  .id-card .field {
    p {
      font-size: 12px !important;
    }
    label {
      font-size: 10px !important;
    }
  }
}
.id-card {
  margin-top: 20px;
  * {
    text-align: left;
  }
  .container {
    padding: 0 !important;
  }
  .field.idt-name {
    flex-basis: unset !important;
  }
  .col {
    flex-basis: content !important;
  }
  .long-box {
    flex-basis: content;
    width: 370px;
    p {
      display: block;
    }
  }
  .flipper > div {
    height: 270px;
    max-width: 423px;
    margin: 0px !important;
    padding: 15px 15px 12px 30px !important;
    border-radius: 8px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.19) !important;
  }
  .field {
    margin-top: 0 !important;
    padding: 4px 0;

    label,
    p {
      color: #092e33;
      display: block;
    }
    label {
      margin-top: 0;
      font-size: 11px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 2.45;
      letter-spacing: normal;
      text-transform: uppercase;
      margin-bottom: 0 !important;
    }

    p {
      margin-top: 0;
      margin-bottom: 0;
      font-size: 14px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.63;
      letter-spacing: normal;
      text-align: left;
    }
  }
}
.table-dataid th {
  font-family: 'Montserrat';
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #035b60;
  padding-left: 147px !important;
  height: 43px;
  border-bottom: 0;
}

table.table-dataid thead th {
  border-bottom: none;
  border-left: solid 1px #d8d8d8;
}

.table-dataid tr td {
  width: 50%;
  border-bottom: none;
  border-left: solid 1px #d8d8d8;
  word-wrap: break-word;
}

.table-dataid tr td {
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.71;
  letter-spacing: normal;
  text-align: left;
  color: #035b60;
  padding-left: 147px !important;
  height: 38px;
  vertical-align: middle;
}
</style>
<style scoped>
.table-dataid {
  width: 95%;
  border-radius: 4px;
  border: solid 1px #d8d8d8;
  font-family: 'Montserrat';
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #035b60;
  table-layout: fixed;
}

.select {
  margin-top: 36px;
  font-family: 'Montserrat';
  font-size: 15px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #035b60;
}
.Step-3 {
  padding-top: 0px;
  margin-top: 0px;
  font-family: 'Montserrat';
  font-size: 20px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.2;
  letter-spacing: normal;
  color: #035b60;
  text-align: left;
}
</style>
